<template>
  <field
    v-bind="$attrs"
    :label="label"
    class="readonly-field"
  >
    <div>
      <slot />
    </div>
  </field>
</template>

<script lang="ts" setup>
import Field from '@utils/inputs/Field.vue';

interface Props{
  label: string;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.readonly-field{
  @apply text-left;
  @apply border-b border-light-gray;
  @apply inline-block;
  @apply pb-4;
}
::v-deep(label){
  @apply text-table-text-gray;
  @apply mb-0;

  font-size: 10px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
::v-deep(.field){
  border: none;
}
</style>
